import React from "react";
import useSeo from "../hooks/useSeo";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, UserCheck, FileCheck2, Check } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useJobModal } from "../context/JobModalContext";
import { FAMILY_IMAGE, BENEFITS } from "../mock";

export default function ForFamilies() {
  const { openJobModal } = useJobModal();
  useSeo("Hire Vetted Nannies & Caregivers | SimplySitter", "Post a job free and hire vetted, background-checked nannies, babysitters, housekeepers and senior caregivers for your family. First month free.");

  return (
    <div>
      <Header />
      <section className="hero-gradient">
        <div className="max-w-7xl mx-auto px-5 pt-14 pb-20 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <h1 className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl text-[#1f1a1b]">Care your family can trust</h1>
            <p className="mt-5 text-[18px] leading-relaxed text-[#5a5254] max-w-xl">
              Post your job for free and receive applications only from experienced, interviewed and background-checked caregivers — nannies, babysitters, housekeepers and senior care.
            </p>
            <button onClick={() => openJobModal({})} className="inline-flex items-center gap-2 mt-8 rounded-xl bg-[#7c2233] hover:bg-[#661b29] text-white font-medium px-8 py-4 shadow-sm transition-colors">
              Post a job free <ArrowRight className="w-4 h-4" />
            </button>
            <p className="mt-3 text-[14px] text-[#8a8285]">1 month free, then $15.99/month. Cancel anytime.</p>
          </div>
          <div>
            <img src={FAMILY_IMAGE} alt="Family with caregiver" className="w-full h-[440px] object-cover rounded-[28px] shadow-[0_30px_70px_-25px_rgba(31,26,27,0.4)]" />
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-5 py-16 grid md:grid-cols-3 gap-5">
          {[[ShieldCheck, "Verified & Trusted", "Every candidate verifies their identity before joining."], [UserCheck, "Interviewed", "We personally interview applicants before approving profiles."], [FileCheck2, "Background Checked", "Background and reference checks help you hire with confidence."]].map(([Icon, t, d]) => (
            <div key={t} className="rounded-2xl border border-black/[0.07] p-7">
              <div className="w-12 h-12 rounded-xl bg-[#f7e4e6] flex items-center justify-center"><Icon className="w-6 h-6 text-[#7c2233]" strokeWidth={1.7} /></div>
              <h3 className="font-display text-xl text-[#1f1a1b] mt-4">{t}</h3>
              <p className="text-[15px] text-[#5a5254] mt-2">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#fdfaf7]">
        <div className="max-w-4xl mx-auto px-5 py-16">
          <div className="rounded-3xl bg-[#fbf3f0] border border-[#7c2233]/10 p-8 sm:p-12">
            <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b]">Everything families get</h2>
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 mt-6">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-[15px] text-[#3a3436]">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#7c2233] flex items-center justify-center shrink-0"><Check className="w-3 h-3 text-white" strokeWidth={3} /></span>{b}
                </li>
              ))}
            </ul>
            <button onClick={() => openJobModal({})} className="inline-flex mt-8 rounded-xl bg-[#7c2233] hover:bg-[#661b29] text-white font-medium px-7 py-3.5 transition-colors">Post a job free</button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
